export default __webpack_public_path__ + "static/media/1_0052.eca66e42.webp";